/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const getStudentData = (userId) =>
  client.get(`/details/${encodeURIComponent(userId)}`);

export default {
  getStudentData,
};
